import { ValuePropsData, ValuePropType } from '@components/ValueProps/types';

export function getDefaultValueProps(type: ValuePropType) {
  const valuePropsData: ValuePropsData = {};
  switch (type) {
    case 'simplifiedstudy': {
      valuePropsData.header = '94% of students say that they get better grades when they use Chegg';
      valuePropsData.subheader = '-2021 Student Survey';
      valuePropsData.bullet1 = 'Search millions of homework answers';
      valuePropsData.bullet2 = 'Ask questions of experts and enthusiasts 24/7';
      valuePropsData.bullet3 = 'Step-by-step Textbook Solutions for 9,000 books';
      // valuePropsData.footer = '$14.95 monthly. Cancel anytime.';
      break;
    }
    case 'cheggmathpricing': {
      valuePropsData.header = 'Subscribe to Chegg Math Solver and get:';
      valuePropsData.bullet1 = 'Unlimited explanations for each step of your math problem';
      valuePropsData.bullet2 = 'Use of the graphing calculator';
      valuePropsData.bullet3 = 'Ad-free workspace';
      // valuePropsData.footer = '$9.95 monthly. cancel anytime.';
      break;
    }
    case 'pla': {
      valuePropsData.header = 'Level up your learning with free beta tools from Chegg';
      valuePropsData.bullet1 =
        'Create instant study guides and exam prep from your course materials';
      valuePropsData.bullet2 =
        'Stay on track with personalized tools that prioritize your coursework';
      valuePropsData.bullet3 = 'Coming soon! Save time brainstorming and planning for big projects';
      break;
    }
  }
  return valuePropsData;
}
